module.exports = __webpack_public_path__ + "img/other.d96915f6.png";